import { MenuOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';

export default function DragHandle({ id }) {
    const { setActivatorNodeRef, listeners, isDragging } = useSortable({ id });

    return (
        <MenuOutlined
            ref={setActivatorNodeRef}
            {...listeners}
            style={{
                cursor: 'move',
                touchAction: 'none',
                opacity: isDragging ? 0.4 : 1,
            }}
        />
    );
}
